import { render, staticRenderFns } from "./VehicleCurrentOwnerWidget.vue?vue&type=template&id=dce0192c&scoped=true&"
import script from "./VehicleCurrentOwnerWidget.vue?vue&type=script&lang=js&"
export * from "./VehicleCurrentOwnerWidget.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCurrentOwnerWidget.vue?vue&type=style&index=0&id=dce0192c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce0192c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce0192c')) {
      api.createRecord('dce0192c', component.options)
    } else {
      api.reload('dce0192c', component.options)
    }
    module.hot.accept("./VehicleCurrentOwnerWidget.vue?vue&type=template&id=dce0192c&scoped=true&", function () {
      api.rerender('dce0192c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleCurrentOwnerWidget.vue"
export default component.exports